export const NEW_SEGMENT = 'newSegment';

export default NEW_SEGMENT;



// WEBPACK FOOTER //
// ./src/components/OfferCampaign/constants.js